import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { OverviewPage } from '../features/overview/page'

export const overviewRoute = createRoute({
  path: 'overview',
  getParentRoute: () => rootRoute,
  component: OverviewPage,
})
